import { copyToClipboard } from '@zealot/shared/browser';
import { useCallback, useEffect, useRef, useState } from 'react';

// gloss
export const useCopyWithFeedback = (resetMs = 4000) => {
  const [isCopied, setIsCopied] = useState(false);
  const resetCopiedTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => clearTimeout(resetCopiedTimeout.current ?? undefined), []);

  const copy = useCallback(
    async (text: string, onError?: (message: string) => void) => {
      const success = await copyToClipboard(text);
      if (!success) {
        onError?.('Could not copy. Select and copy it manually.');
        return false;
      }
      setIsCopied(true);
      clearTimeout(resetCopiedTimeout.current ?? undefined);
      resetCopiedTimeout.current = setTimeout(() => setIsCopied(false), resetMs);
      return true;
    },
    [resetMs],
  );

  return { isCopied, copy };
};
